module.exports = __webpack_public_path__ + "static/media/light-honeycomb--dark--1920x1080.d3ea4798.png";